/**
 * /pilot/cancel — landing page when a user closes the LS checkout without paying.
 * Gives them a single, frictionless way back to the qualification form.
 */
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, RefreshCcw, MessageCircle } from 'lucide-react';
import Logo from '@/components/Logo';

export default function PilotCancel() {
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="pilot-cancel-page">
      <header className="border-b border-border bg-card/60 backdrop-blur-xl">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-4 py-4">
          <Link to="/"><Logo size={30} variant="full" /></Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center p-4">
        <Card className="max-w-xl w-full p-10" data-testid="pilot-cancel-card">
          <div className="w-14 h-14 rounded-2xl bg-amber-50 border border-amber-200 flex items-center justify-center mb-5">
            <XCircle className="w-7 h-7 text-amber-600" />
          </div>
          <h1 className="text-2xl font-heading font-bold mb-2">Checkout cancelled</h1>
          <p className="text-sm text-muted-foreground mb-6">
            No charge was made. Your qualification record is still active — you can
            retry the payment any time from the email we sent you, or from here.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/pilot-qualification" className="flex-1" data-testid="pilot-cancel-retry-btn">
              <Button className="bg-primary hover:bg-primary/90 w-full">
                <RefreshCcw className="w-4 h-4 mr-2" /> Restart qualification
              </Button>
            </Link>
            <a href="mailto:pilot@veridex-one.com" className="flex-1" data-testid="pilot-cancel-contact-btn">
              <Button variant="outline" className="w-full">
                <MessageCircle className="w-4 h-4 mr-2" /> Talk to Veridex
              </Button>
            </a>
          </div>
        </Card>
      </main>
    </div>
  );
}
